import Backbone from 'backbone'
import _ from 'lodash'
import GridSnap from './type/grid'
import WidgetSnap from './type/widget'

const SnapType = Object.freeze({
  WIDGETS: 'widgets', // default - lines are based on other widgets
  GRID: 'grid', // snap based on a 10x10 grid
  NONE: 'none' // don't snap, no lines
})

const Snaps = {}

Snaps[SnapType.WIDGETS] = WidgetSnap
Snaps[SnapType.GRID] = GridSnap
Snaps[SnapType.NONE] = null // empty

const SnapGrid = 16 // If the canvas is set to a grid system, this defines each block. Must match what's defined in canvas.scss


var Snapping = Backbone.View.extend({

  initialize: function (options) {
    this.canvas = options.canvas

    // Something is triggering some snap lines (e.g. drag, resize). Set the snaps based on the current canvas snapType
    let Type = Snaps[this.canvas.collection.snapType]
    if (Type) {
      this.snapType = new Type({canvas: this.canvas, el: this.canvas.el, gridSize: SnapGrid})
    }
  },

  /**
   * Determines if the incoming `area` should snap to a new location
   * @param {Object} area - The virtual area of where the wob is moved
   * @param {Object} previousArea - Used for drawing guidelines
   * @param {String} [handleType] The type of handle if it's a resize
   */
  snap: function (area, previousArea, handleType) {
    if (!this.snapType) {
      // canvas is not in a snapping mode
      return {}
    }

    // Make sure the area and previousArea have all bounds (i.e. right/bottom) properties set
    area = this.snapType.setBounds(area)
    previousArea = this.snapType.setBounds(previousArea)
    return this.snapType.snap(area, previousArea, handleType)
  },

  release: function () {
    if (this.snapType) {
      this.snapType.release()
      this.snapType = null
    }
  }
})

export default Snapping

export {SnapGrid, SnapType}
